import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBxPercent = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m19 5-2-1.5-12 15L7.21 20l5.895-7.467L19 5ZM19 17.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
	}), /* @__PURE__ */ _jsx("circle", {
		fill: "currentColor",
		cx: 7.5,
		cy: 6.5,
		r: 2.5
	})]
});
export default SvgBxPercent;
